import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from '../src/components/Header.jsx';
import  Footer  from './components/Footer';
import  Home  from './pages/Home/Home.jsx';
// import { AboutComponent } from './pages/Home/AboutComponent';
import About from './pages/About/About.jsx';
import Service from './pages/Service/Service.jsx';
import Contact from './pages/Contact/Contact.jsx';
import Terms from './pages/Terms.jsx';
import Privacy from './pages/Privacy.jsx';

export const Router = () => {
    return (
        <BrowserRouter>
            <Header />
            <Routes>
                <Route path='/' element={<Home/>} />
<Route path='About' element={<About/>}/>
<Route path='Service' element={<Service/>}/>
<Route path='Contact' element={<Contact/>}/>
<Route path='Terms' element={<Terms/>}/>
<Route path='Privacy' element={<Privacy/>}/>
            </Routes>
            <Footer />
        </BrowserRouter>
    );
};
